(() => {
  const descriptions = document.querySelectorAll("[data-pfa-description]");
  for (const description of descriptions) {
    description.classList.add("pfa-description--enhanced");
    for (const more of description.querySelectorAll(".pfa-description__more")) {
      const summary = more.querySelector("summary");
      if (!summary) continue;
      const closedText = summary.textContent;
      more.addEventListener("toggle", () => {
        summary.textContent = more.open ? "Show fewer compatible fitments" : closedText;
      });
    }
  }
})();